import { c as _c } from "react/compiler-runtime";
import { CONTACT_API } from 'modules/contacts/api/contact-api';
import { ContactFilterSavedApiInterface } from 'modules/contacts/types/contact-filter-interface';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
import { baseFetcher } from 'shared/utils/http-client';
import useSWR from 'swr';
export function useContactSavedFilters() {
  const $ = _c(5);
  const {
    user
  } = useUser();
  let t0;
  if ($[0] !== user) {
    t0 = () => {
      if (user) {
        return `${CONTACT_API}/filters/list?pagination[limit]=50`;
      }
      return null;
    };
    $[0] = user;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const {
    data: savedFields,
    mutate: mutateSavedFields
  } = useSWR(t0, baseFetcher);
  let t1;
  if ($[2] !== mutateSavedFields || $[3] !== savedFields) {
    t1 = {
      savedFields,
      mutateSavedFields
    };
    $[2] = mutateSavedFields;
    $[3] = savedFields;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  return t1;
}